import { createContext, useContext } from 'react';
import {
  AlignJustify, AlignLeft, CalendarDays, ChevronDownCircle, CircleDot, Clock, CloudUpload, Grid3x3, Heading,
  Image as ImageIcon, LayoutGrid, Rows3, SlidersHorizontal, SquareCheck, Star, Youtube,
} from 'lucide-react';

/*
 * Lo que comparten todas las piezas del editor sin pasarlo de mano en mano: el formulario, quién
 * está activo y las acciones de edición (que registran deshacer y encolan el guardado).
 * Lo crea FormEditor.jsx.
 */
export const ContextoEditor = createContext(null);
export const useEditor = () => useContext(ContextoEditor);

/** Ícono de cada tipo (los nombres de `TIPOS[tipo].icono` de lib/formularios.js). */
export const ICONOS_TIPO = {
  texto_corto: AlignLeft,
  parrafo: AlignJustify,
  opcion_multiple: CircleDot,
  casillas: SquareCheck,
  desplegable: ChevronDownCircle,
  archivo: CloudUpload,
  escala: SlidersHorizontal,
  calificacion: Star,
  cuadricula_opcion: Grid3x3,
  cuadricula_casillas: LayoutGrid,
  fecha: CalendarDays,
  hora: Clock,
  titulo: Heading,
  imagen: ImageIcon,
  video: Youtube,
  seccion: Rows3,
};

/** Id de la tarjeta del encabezado (título y descripción del formulario), que no es un item. */
export const ENCABEZADO = '__encabezado__';

export const detalleError = (err, defecto) => {
  const d = err?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (d && typeof d.mensaje === 'string') return d.mensaje;
  return defecto;
};
